import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { formSubmitEmbedEntrypoint } from '@jira/spa-apps__software-form-submit-embed/src/formSubmitEmbedEntrypoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import, camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { softwareFormSubmitEmbedClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareFormSubmitEmbedClassicRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const formSubmitEmbedPageEntrypoint = createChromelessEntryPoint({
	main: formSubmitEmbedEntrypoint,
});

export const softwareFormSubmitEmbedClassicRouteEntry: Route = createEntry(
	softwareFormSubmitEmbedClassicRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'classic-form-submit-embed',
		layout: chromelessLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		// eslint-disable-next-line camelcase
		resources: [DEPRECATED_DO_NOT_USE_projectDetailsResource],

		entryPoint: () => {
			return formSubmitEmbedPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
